var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mediaId)?_c('div',[_c('media-viewer',{ref:"mediaViewer",attrs:{"data":_vm.media,"scene-index":_vm.sceneIndex},on:{"error":_vm.loadingError}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }